import "../../../assets/css/footer.css";

export default function Footer() {
  return (
    <footer className="cl-footer">
      <div className="cl-footer__grid">

        {/* Brand */}
        <div className="cl-footer__brand">
          <span className="cl-footer__logo">CODELUNE</span>
          <p className="cl-footer__desc">
            Precision engineered digital experiences for the modern obsidian age.
          </p>
        </div>

        {/* About column */}
        <div className="cl-footer__col">
          <h4>About</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
            <li><a href="/story">Our Story</a></li>
            <li><a href="/team">Our Team</a></li>
          </ul>
        </div>

        {/* Connect column */}
        <div className="cl-footer__col">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://wa.me/62895635363191?text=Hallo%20Codelune%2C%20saya%20mau%20tanya-tanya%20dulu%20tentang%20project%20digital.%20Terima%20kasih!" target="_blank" rel="noreferrer">WhatsApp</a></li>
            <li><a href="mailto:hello@codelune.com">Email</a></li>
          </ul>
        </div>

        {/* Location column — simple address, no iframe */}
        <div className="cl-footer__col">
          <h4>Lokasi</h4>
          <ul>
            <li style={{ lineHeight: 1.6, color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem' }}>
              Tomohon, Sulawesi Utara<br />Indonesia
            </li>
          </ul>
        </div>

      </div>

      <div className="cl-footer__bottom">
        <p>© 2026 CODELUNE. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  );
}